import React from "react";

function AnexosTab({ anexos, processData, dataFormato }) {
  return (
    <div className="tab-pane fade" id="terceira-aba" role="tabpanel">
      <div className="card-body table-responsive p-0">
        <table className="table table-striped table-bordered mt-10">
          <thead>
            <tr>
              <th>Número do Processo</th>
              <th>Data da Inserção do Anexo</th>
              <th>Nome do Anexo</th>
              <th>Referente</th>
              <th>Ação</th>
            </tr>
          </thead>
          <tbody>
            {anexos.map((anexo) => (
              <tr key={anexo.id}>
                <td>{processData.processo}</td>
                <td>{dataFormato(anexo.data)}</td>
                <td>
                  <label title="Clique para visualizar o arquivo">
                    <a
                      style={{ color: "green" }}
                      href={`https://guias.almeidaenogueira.com.br/api/download/${anexo.id}`}
                    >
                      <i className="fa fa-cloud-download mr-3" />
                      {anexo.nome}
                    </a>
                  </label>
                </td>
                <td>{anexo.referente}</td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default AnexosTab;
